import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer';
import { Helmet } from "react-helmet-async";

export default function Gmfmadagascar() {
  return (
    <>
        <Helmet>
            <title>GMF Madagascar | Gandhi Mandela Foundation</title>
            <meta name="description" content="GMF Madagascar" />
        </Helmet>
        <Header/>
                <section className="page-header">
                    <div className="container">
                    <div className="breadcrumb">
                        <a href="/">Home</a>
                        <span>/</span>
                        <span>GMF Madagascar</span>
                    </div>
                    <h1>GMF Madagascar</h1>
                    </div>
                </section>
                
                <section className="jury-members">
                <div className="container">
                    <div className="members-grid">
                        <div className="member-card">
                            <div className="member-img">
                            <img src="img/members/Luis-Herald-Rasolondrainy.png" alt="Luis Herald Rasolondrainy" />
                            </div>
                            <h3>Luis Herald Rasolondrainy</h3>
                            <span>(President Madagascar)</span>
                        </div>
                        <div className="member-card">
                            <div className="member-img">
                            <img src="img/members/Dr.-Gbola-Adeleke.png" alt="DR. Gbola Adeleke" />
                            </div>
                            <h3>DR. Gbola Adeleke</h3>
                            <span>(PhD, Councillor and Former Mayor of Dacorum, United Kingdom, Humanitarian Affairs Advisor, GMF Madagascar)</span>
                        </div>
                        <div className="member-card">
                            <div className="member-img">
                            <img src="img/members/Jules-Andriantsiory-Ramandimbisoa.png" alt="Jules Andriantsiory Ramandimbisoa" />
                            </div>
                            <h3>Jules Andriantsiory Ramandimbisoa</h3>
                            <span>(Director of Communication)</span>
                        </div>
                        <div className="member-card">
                            <div className="member-img">
                            <img src="img/members/Dr.-Olivia-Promise-KABATESI.png" alt="DR. Olivia Promise KABATESI" />
                            </div>
                            <h3>DR. Olivia Promise KABATESI</h3>
                            <span>(Human rights officer, GMF)</span>
                        </div>
                        <div className="member-card">
                            <div className="member-img">
                            <img src="img/members/ANDREAS-RAMANGASON.jpg" alt="ANDREAS RAMANGASON" />
                            </div>
                            <h3>ANDREAS RAMANGASON</h3>
                            <span>(Program Manager – Culture, Arts and Gender GMF)</span>
                        </div>
                    </div>
                </div>
                </section>
                {/* =========================
                FOOTER
                ========================== */}
            <Footer/>
            </>
  )
}
